import { Image } from "@components/shares";
import notFound from "@assets/images/404.svg";
const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-6">
      <Image 
        src={notFound} 
        alt="404 Not Found" 
        className="w-64 h-64"
      />
      <h1 className="text-2xl text-center">Không tìm thấy trang này, quay về trang chủ</h1>
      <a 
        href="/" 
        className="px-6 py-2 mt-4 text-white bg-blue-600 rounded-md hover:bg-blue-700"
      >
        Trang chủ
      </a>
    </div>
  );
};

export default NotFound;